import { render, staticRenderFns } from "./ComplaintOverviewCell.vue?vue&type=template&id=53819ac3&scoped=true"
import script from "./ComplaintOverviewCell.vue?vue&type=script&lang=js"
export * from "./ComplaintOverviewCell.vue?vue&type=script&lang=js"
import style0 from "./ComplaintOverviewCell.vue?vue&type=style&index=0&id=53819ac3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53819ac3",
  null
  
)

export default component.exports